import styled from 'styled-components';

const ButtonAsLink = styled.button.attrs({
  type: 'button'
})`
  display: block;
  text-align: left;
  padding: 2rem 0 0;
  border: 0;
  background: none;
  font-family: inherit;
  text-decoration: underline;
  cursor: pointer;

  ${({ theme }) => `
    color: ${theme.color('grey_dark')};
    font-size: ${theme.fontSize('s')};
  `}
`;

export default ButtonAsLink;
